document.addEventListener("DOMContentLoaded", function () {
  const addButton = document.getElementById("bxgy-add-btn");

  if (addButton) {
    addButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Disable button and show loading state
      addButton.setAttribute("aria-disabled", "true");
      addButton.classList.add("loading");

      // Get product IDs
      const buyProductId = addButton.getAttribute("data-buy_product_id");
      const getProductId = addButton.getAttribute("data-get_product_id");

      // Prepare FormData for both products
      const formData = new FormData();
      formData.append("items[0][id]", buyProductId);
      formData.append("items[0][quantity]", "1");
      formData.append("items[1][id]", getProductId);
      formData.append("items[1][quantity]", "1");

      // Find cart drawer (try multiple selectors to match your theme)
      const cart = document.querySelector(
        "cart-drawer, cart-notification, [data-ajax-cart-toggle], [data-cart-toggle], .site-header__cart, .cart-drawer__toggle"
      );
      if (cart) {
        formData.append(
          "sections",
          cart.getSectionsToRender?.().map((section) => section.id) ||
            "cart-drawer"
        );
        formData.append("sections_url", window.location.pathname);
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `HTTP error ${response.status}: Failed to add products`
            );
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            // Handle error (e.g., sold out, invalid variant)
            const errorWrapper =
              addButton.nextElementSibling?.classList.contains(
                "product-form__error-message-wrapper"
              )
                ? addButton.nextElementSibling
                : document.createElement("div");
            errorWrapper.classList.add("product-form__error-message-wrapper");
            const errorElement =
              errorWrapper.querySelector(".product-form__error-message") ||
              document.createElement("span");
            errorElement.classList.add("product-form__error-message");
            errorElement.textContent =
              response.description ||
              response.message ||
              "Failed to add products to cart.";
            errorWrapper.appendChild(errorElement);
            addButton.parentNode.insertBefore(
              errorWrapper,
              addButton.nextSibling
            );
            errorWrapper.removeAttribute("hidden");
            return;
          }

          // If no cart drawer, redirect to /cart
          if (!cart) {
            window.location = "/cart";
            return;
          }

          // Try to render cart contents or trigger drawer
          try {
            if (cart.renderContents) {
              cart.renderContents(response);
            } else {
              // Dispatch custom event or simulate click
              const toggle =
                cart.querySelector(
                  "[data-ajax-cart-toggle], [data-cart-toggle], .cart-drawer__toggle, .site-header__cart"
                ) || cart;
              if (toggle) {
                toggle.click();
              } else {
                cart.dispatchEvent(
                  new CustomEvent("cart:open", { bubbles: true })
                );
              }
            }

            // Ensure cart drawer is not marked as empty
            if (cart.classList.contains("is-empty")) {
              cart.classList.remove("is-empty");
            }
          } catch (e) {
            console.error("Error rendering cart drawer:", e);
            // Fallback to redirect if drawer fails
            window.location = "/cart";
          }
        })
        .catch((e) => {
          console.error("Error adding products:", e);
          const errorWrapper = document.createElement("div");
          errorWrapper.classList.add("product-form__error-message-wrapper");
          errorWrapper.innerHTML =
            '<span class="product-form__error-message">Failed to add products to cart. Please try again.</span>';
          addButton.parentNode.insertBefore(
            errorWrapper,
            addButton.nextSibling
          );
        })
        .finally(() => {
          addButton.classList.remove("loading");
          addButton.removeAttribute("aria-disabled");
        });
    });
  }
});
